const PrintProviders = () => import('./_views/printProviders');

export default [
  {
    path: '/settings/print-providers',
    name: 'printProviders',
    component: PrintProviders,
    meta: {
      title: 'Print Providers',
      group: 'settings',
      navigation: {
        position: 1,
        name: 'Print Providers',
        specialQueries: ['suffix'],
        to: {
          name: 'printProviders',
          query: {
            suffix: '',
          },
        },
      },
    },
  },
];
